// removed by extract-text-webpack-plugin
module.exports = {"Center":"KDzwcRoPjWGzBdsw-a-gI","Choices":"_2NbtTOYqCGge0KC1iETEQZ","Columns":"_2zISZuOolnb3XylxLduLvq","LeftPadding":"_2UWzyipA80A9iaUyqFynFp"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ChooseCategory/ChooseCategory.css
// module id = 336
// module chunks = 0